import { CircularProgress } from '@mui/material';

import { Suspense } from 'react';
import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';
import { UserType } from 'utils/ACLHelper';
import Roles from 'utils/enums/Roles';

import CompanyDetailPage from './CompanyDetailPage';
import { InvoiceManagement } from './InvoiceManagement';
import { JobOfferDetail } from './JobOfferDetail';
import { JobOffers } from './JobOffers';
import { ManageCompanies } from './ManageCompanies';
import { ManageJobs } from './ManageJobs';
import ManageMyJobs from './ManageMyJobs';
import PricingTable from './PricingTable';
import { StudentJobOffers } from './StudentJobOffer';
import { StudentJobOfferDetailView } from './StudentJobOffer/StudentJobOfferDetail';

export const Jobs = ({ currentUser }) => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '80vh'
          }}
        >
          <CircularProgress />
        </div>
      }
    >
      <Routes>
        <Route
          index
          element={
            <PrivateRoute notAnonymous user={currentUser}>
              <JobOffers />
            </PrivateRoute>
          }
        />
        <Route
          path="manage"
          element={
            <PrivateRoute
              requires={{
                entitlements: [Roles.JOBMARKET_ADMIN]
              }}
              user={currentUser}
            >
              <ManageJobs />
            </PrivateRoute>
          }
        />
        <Route
          path="studentOffers"
          element={
            <PrivateRoute user={currentUser} notAnonymous>
              <StudentJobOffers />
            </PrivateRoute>
          }
        />
        <Route
          path="studentOffers/:id"
          element={
            <PrivateRoute notAnonymous user={currentUser}>
              <StudentJobOfferDetailView />
            </PrivateRoute>
          }
        />
        <Route
          path="my"
          element={
            <PrivateRoute
              requires={{
                roles: [Roles.EMPLOYEE, Roles.LECTURER, Roles.PROFESSOR, Roles.JOBMARKET_ADMIN]
              }}
              user={currentUser}
            >
              <ManageMyJobs />
            </PrivateRoute>
          }
        />
        <Route
          path=":id"
          element={
            <PrivateRoute notAnonymous user={currentUser}>
              <JobOfferDetail />
            </PrivateRoute>
          }
        />
        <Route path={'/pricing'} element={<PricingTable hasUser={currentUser ? true : false} />} />
      </Routes>
    </Suspense>
  );
};

export const Companies = ({ currentUser }) => {
  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.STUDENT, Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR],
              entitlements: [Roles.JOBMARKET_ADMIN, Roles.INCOMING_USER],
              userType: UserType.INCOMING
            }}
            user={currentUser}
          >
            <ManageCompanies />
          </PrivateRoute>
        }
      />
      <Route
        path="invoicing"
        element={
          <PrivateRoute requires={{ entitlements: [Roles.JOBMARKET_ADMIN] }} user={currentUser}>
            <InvoiceManagement />
          </PrivateRoute>
        }
      />
      <Route
        path=":id/invoices"
        element={
          <PrivateRoute companyUser user={currentUser}>
            <InvoiceManagement company />
          </PrivateRoute>
        }
      />
      <Route
        path=":id"
        element={
          <PrivateRoute notAnonymous user={currentUser}>
            <CompanyDetailPage />
          </PrivateRoute>
        }
      />
      <Route
        path="university"
        element={
          <PrivateRoute notAnonymous user={currentUser}>
            <CompanyDetailPage />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
